<template>
  <Modal
    :show="show"
    width="60%"
    min-height="50%"
    hide-default-actions
    @close="close"
  >
    <template #title>
      Write a Job Post
    </template>

    <template #content>
      <div class="d-flex ga-6 create-draft-columns">
        <div class="create-draft-left">
          <div class="mb-4">
            Begin a new draft
          </div>

          <CreateDraftForm
            ref="draftForm"
            @created="onCreated"
            @template-changed="selectedTemplateId = $event"
          />
        </div>

        <v-divider vertical />

        <div class="create-draft-right">
          <TemplatePreviewPanel :template-id="selectedTemplateId" />
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import CreateDraftForm from '@/components/shared/CreateDraftForm.vue';
import Modal from '@/components/shared/Modal.vue';
import TemplatePreviewPanel from '@/components/shared/TemplatePreviewPanel.vue';

export default {
  name: 'CreateDraftModal',

  components: {
    Modal,
    CreateDraftForm,
    TemplatePreviewPanel,
  },

  props: {
    templateList: { type: Array, default: () => [] },
    show: { type: Boolean, default: false },
  },

  emits: ['close'],

  data() {
    return {
      selectedTemplateId: null,
    };
  },

  methods: {
    close() {
      this.$refs.draftForm.resetForm();
      this.$emit('close');
    },
    onCreated(responseJSON) {
      return this.$router.replace({
        name: 'editor-view-reload',
        params: { id: responseJSON.jobId },
        query: responseJSON.isFirstDraft ? { writeWithFirstDraft: true } : undefined,
      });
    },
  },
};
</script>

<style scoped lang="less">
.create-draft-columns {
  align-items: flex-start;
}

.create-draft-left {
  width: 320px;
  flex-shrink: 0;
}

.create-draft-right {
  flex: 1;
  min-width: 0;
}
</style>
